import { isPast } from "date-fns";
import { useCountdown } from "@/hooks/useCountdown";
import { useEffect } from "react";
import type { Maybe } from "types/utilities";

const useOtpExpiry = (expiresAt: Maybe<Date>, onExpire: () => void) => {
  const [_, secondsToNow] = useCountdown(expiresAt || new Date(0));

  useEffect(() => {
    if (!expiresAt) return;
    if (isPast(expiresAt) || secondsToNow <= 0) onExpire();
  }, [secondsToNow, onExpire]);
};

export { useOtpExpiry };
